import axios from "axios";
import { configUrl } from "../config";

export const addJEERank = async (userId, rank) => {
    try {
        const response = await axios.post(`${configUrl.AssessmentServer}/api/User/AddJEERank/${userId}/${rank}`);
        return response;
    } catch (error) {
        console.error('Error adding JEE rank to user:', error);
        throw error;
    }
};
